export default __webpack_public_path__ + "static/media/trailer.e89c25bc.svg";